import {
  FETCH_APPROVEMENTS,
  CLEAR_SELECTED_APPROVEMENTS,
} from "actions/types";

import {
  approvementsRead,
} from "../api";
import {
  dataFailure,
} from "./general";


const fetchApprovmentsSuccess = (values) => {
  return {
    type: FETCH_APPROVEMENTS,
    payload: values,
  };
};

export const fetchApprovements = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(approvementsRead(values));
      await dispatch(fetchApprovmentsSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const clearSelectedApprovements = () => {
  return {
    type: CLEAR_SELECTED_APPROVEMENTS,
  };
}
